import { Button, Flex } from '@mantine/core';
import { Navigate } from 'react-router-dom';

import { useIsAdminAuth } from '@admin/hooks';
import { AuthLayout } from '@features/auth/AuthLayout';
import { useSettings } from '@hooks/useSettings';

const logoGoogle = new URL(`../../assets/icons/logo_google.svg`, import.meta.url).href;

export const AdminLogin = () => {
  const isAuth = useIsAdminAuth();
  const { data: settings } = useSettings();

  if (isAuth) {
    return <Navigate to={`/${settings.adminPath}`} replace />;
  }

  const loginWithGoogle = () => {
    window.location.href = `${settings.apiUrl}/auth/google`;
  };

  return (
    <AuthLayout>
      <Flex h={80} align="center" justify="center">
        <Button leftSection={<img src={logoGoogle} alt="" height={32} width={32} />} variant="light" onClick={loginWithGoogle}>
          Login with Google
        </Button>
      </Flex>
    </AuthLayout>
  );
};
